module.exports = __webpack_public_path__ + "static/media/cmaa.ab355928.png";